export default __webpack_public_path__ + "static/cemetery-49eac994e2283595ec3d1f90e9bb1e6c.svg";